import React from 'react';
import { NavLink } from 'react-router-dom';

export default function NavItems() {
    return (
        <ul>
            <li>
                <NavLink to="/match" activeStyle={{ fontWeight: 600 }}>
                    Match
                </NavLink>
            </li>
            <li>
                <NavLink to="/groei" activeStyle={{ fontWeight: 600 }}>
                    Groei
                </NavLink>
            </li>
            {/* <li>
                <NavLink to="/stage" activeStyle={{ fontWeight: 600 }}>
                    Stage
                </NavLink>
            </li> */}
            <li>
                <NavLink to="/netwerk" activeStyle={{ fontWeight: 600 }}>
                    Netwerk
                </NavLink>
            </li>
            <li>
                <NavLink to="/over-nxt" activeStyle={{ fontWeight: 600 }}>
                    Over NXT
                </NavLink>
            </li>
            <li>
                <NavLink to="/nieuws" activeStyle={{ fontWeight: 600 }}>
                    Nieuws
                </NavLink>
            </li>
            <li>
                <NavLink to="/agenda" activeStyle={{ fontWeight: 600 }}>
                    Agenda
                </NavLink>
            </li>
        </ul>
    );
}
